import type { SearchGeoGroupInput } from '@/shared/utils/partnerships-history-filters';
import type { SearchStatus } from './partnerships-wizard-types';

export type HistorySortKey = 'recent' | 'oldest' | 'results';

export interface HistoryFilters {
  text: string;
  status: SearchStatus | 'all';
  sort: HistorySortKey;
}

export interface SearchSummary {
  search_id: string;
  status: SearchStatus;
  created_at: string;
  properties_retrieved: number;
  city: string;
  neighbourhood?: string;
  query?: Record<string, unknown>;
}

export interface SearchGeoGroup {
  geo_key: string;
  city: string;
  neighbourhood?: string;
  searches: SearchSummary[];
}

export interface PartnershipsHistoryState {
  groups: SearchGeoGroupInput[];
  loading: boolean;
  error: string | null;

  filters: HistoryFilters;
  setFilters: (patch: Partial<HistoryFilters>) => void;

  loadSearches: (agencyId: string) => Promise<void>;
}

export const INITIAL_HISTORY_FILTERS: HistoryFilters = {
  text: '',
  status: 'all',
  sort: 'recent',
};
